var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFacebookBlack = function SvgFacebookBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.991,
    height: 17.999,
    viewBox: "0 0 17.991 17.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook-black-icon",
    d: "M142.617,128a3.379,3.379,0,0,1,3.374,3.374V142.62a3.379,3.379,0,0,1-3.374,3.374h-2.2v-6.975h2.331l.351-2.717h-2.682v-1.733a1.5,1.5,0,0,1,.275-.984,1.363,1.363,0,0,1,1.071-.328l1.429-.011v-2.424a15.7,15.7,0,0,0-2.084-.106,3.479,3.479,0,0,0-2.548.937,3.542,3.542,0,0,0-.954,2.647v2h-2.342v2.717H137.6v6.969h-6.231A3.379,3.379,0,0,1,128,142.615V131.369a3.379,3.379,0,0,1,3.374-3.374Z",
    transform: "translate(-128 -127.995)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebookBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook-black.60417d3d.svg";
export { ForwardRef as ReactComponent };